export function App() {
    return <h1>Hello world - {process.env.ENV}</h1>;
  }